/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={49} height={49.163} viewBox="515 245 49 49.163" {...props}>
    <g data-name="logo-lockup-square" fillRule="evenodd">
      <path
        d="M9.947 49.416a9.932 9.932 0 0 1-7.04-2.888A10.094 10.094 0 0 1 .02 39.5V12.784c0-1.331 1.077-.48 2.408-.48 1.332 0 2.408-.851 2.408.48V39.42a5.274 5.274 0 0 0 1.508 3.622A5.114 5.114 0 0 0 9.947 44.6H38.56c2.83 0 5.13-2.3 5.13-5.13a2.406 2.406 0 0 1 2.408-2.408 2.406 2.406 0 0 1 2.408 2.408c0 5.492-4.454 9.946-9.946 9.946H9.947Z"
        fill='url("#a")'
        transform="translate(515 244.747)"
        data-name="f"
      />
      <path
        d="M563.585 248.867h-.01l-3.436-3.436a1.467 1.467 0 0 0-1.037-.431 1.475 1.475 0 0 0-1.058 2.496h-33.098c-5.492 0-9.946 4.445-9.946 9.937a2.406 2.406 0 0 0 2.408 2.408 2.406 2.406 0 0 0 2.408-2.408c0-2.83 2.3-5.12 5.13-5.12h33.089a1.469 1.469 0 0 0 .01 2.046c.273.284.655.44 1.047.43.391 0 .763-.156 1.037-.43l3.437-3.427a1.468 1.468 0 0 0 .01-2.075Z"
        fill={props.fill ? props.fill : '#f000'}
        data-name="Path 701"
      />
      <path
        d="M558.69 284.393v-24.307a2.406 2.406 0 0 1 2.409-2.409 2.406 2.406 0 0 1 2.408 2.409v24.307c0 1.331-4.817 1.331-4.817 0Z"
        fill={props.fill ? props.fill : '#f000'}
        data-name="g"
      />
      <path
        d="M527.168 269.229h5.1a3.538 3.538 0 0 0 3.77-3.29c0-.127.01-.254 0-.371a3.122 3.122 0 0 0-1.107-2.604 3.798 3.798 0 0 0-2.476-.715h-5.287v6.98Zm-3.367-10.054h8.683a6.686 6.686 0 0 1 4.533 1.508 6.237 6.237 0 0 1 2.212 4.894 6.37 6.37 0 0 1-4.288 6.354l5.257 10.367h-4.004l-4.718-9.995h-4.298v10.005h-3.367v-23.143Z"
        fill={props.fill ? props.fill : '#f000'}
        data-name="h"
      />
      <path
        d="M542.058 265.568h3.172v1.928h.059a5.083 5.083 0 0 1 4.14-1.928 5.316 5.316 0 0 1 3.593 1.429 5.674 5.674 0 0 1 1.694 4.249v11.062h-3.201v-9.927a3.55 3.55 0 0 0-.891-2.614 2.92 2.92 0 0 0-2.242-.92 3.05 3.05 0 0 0-2.261.92 3.514 3.514 0 0 0-.9 2.614v9.927h-3.173v-16.74Z"
        fill={props.fill ? props.fill : '#f000'}
        data-name="i"
      />
    </g>
    <defs fill={props.fill ? props.fill : '#f000'}>
      <linearGradient x1={0.079} y1={-0.171} x2={0.916} y2={0.942} id="a" fill={props.fill ? props.fill : '#f000'}>
        <stop stopColor={props.fill ? props.fill : '#f000'} offset={0} />
        <stop stopColor={props.fill ? props.fill : '#f000'} offset={1} />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// src/assets/LogoSmall.jsx